import React from 'react';

const LinkedinHoverBlue = ({ ...props }) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.57143 16V5.32143H0.25V16H3.57143ZM1.92857 3.85714C2.42857 3.85714 2.89286 3.67857 3.28571 3.28571C3.64286 2.92857 3.85714 2.46429 3.85714 1.92857C3.85714 1.42857 3.64286 0.964286 3.28571 0.571429C2.89286 0.214286 2.42857 0 1.92857 0C1.39286 0 0.928571 0.214286 0.571429 0.571429C0.178571 0.964286 0 1.42857 0 1.92857C0 2.46429 0.178571 2.92857 0.571429 3.28571C0.928571 3.67857 1.39286 3.85714 1.92857 3.85714ZM16 16V10.1429C16 8.5 15.75 7.28571 15.2857 6.5C14.6429 5.53571 13.5714 5.03571 12.0357 5.03571C11.25 5.03571 10.6071 5.25 10.0357 5.60714C9.5 5.92857 9.10714 6.32143 8.89286 6.78571H8.85714V5.32143H5.67857V16H8.96429V10.7143C8.96429 9.89286 9.07143 9.25 9.32143 8.82143C9.60714 8.25 10.1429 7.96429 10.9286 7.96429C11.6786 7.96429 12.1786 8.28571 12.4643 8.92857C12.6071 9.32143 12.6786 9.92857 12.6786 10.7857V16H16Z"
      fill="#2277D1"
    />
  </svg>
);

export default LinkedinHoverBlue;
